import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ICON_REGISTRY_TOKEN } from './icon-registry';

@Component({
    selector: 'app-svg-icon',
    standalone: true,
    template: `
        @if (iconDef(); as def) {
        <svg
            [attr.viewBox]="def.viewBox"
            [attr.width]="size()"
            [attr.height]="size()"
            [attr.fill]="def.strokeBased ? 'none' : color()"
            [attr.stroke]="def.strokeBased ? strokeColor() || color() : null"
            [attr.stroke-width]="def.strokeBased ? strokeWidth() : null"
            [attr.stroke-linecap]="def.strokeBased ? 'round' : null"
            [attr.stroke-linejoin]="def.strokeBased ? 'round' : null"
            [innerHTML]="safeContent()"
        ></svg>
        }
    `,
    styleUrl: './svg-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
    /** Icon name from the registry */
    name = input.required<string>();
    /** Size in px (applied to both width and height) */
    size = input<number>(20);
    /** Fill color for path-based icons */
    color = input<string>('currentColor');
    /** Stroke color for stroke-based icons (defaults to color if not set) */
    strokeColor = input<string | undefined>(undefined);
    /** Stroke width for stroke-based icons */
    strokeWidth = input<number>(2.5);

    private readonly iconRegistry = inject(ICON_REGISTRY_TOKEN);

    iconDef = computed(() => this.iconRegistry[this.name()] ?? null);

    safeContent = computed<SafeHtml>(() => {
        const def = this.iconDef();
        return def ? this.sanitizer.bypassSecurityTrustHtml(def.content) : '';
    });

    constructor(private sanitizer: DomSanitizer) {}
}

